import React, { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Spinner } from "react-bootstrap";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import DetailGameQuestionModal from "../../Components/Modals/DetailGameQuestionModal.js";
import { QUESTION_TYPE } from "../../constants.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import { useGetAllGameQuestionQuery } from "../../Data/services/gameApi.js";
// import { useDeleteBusinessTypeMutation, useGetAllBusinessTypeMutation, useGetAllBusinessTypeQuery } from "../../Data/services/businessTypeApi.js";
// import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
// const CustomerBlockModal = lazy(() =>
//   import("../../Components/Modals/CustomerBlockModal.js")
// );

const GameQuestionManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const dummyData = [
    {
      id: 900,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:43:00.000Z",
      updatedAt: "2025-04-21T14:43:11.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "iste quibusdam temporibus",
        short_answer: "program",
        image: null,
        category_id: 1,
        points: 50,
        question_type: 50,
        updatedAt: "2025-03-10T10:22:12.000Z",
        deletedAt: null,
      },
      team_name: "you",
    },
    {
      id: 899,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:43:00.000Z",
      updatedAt: "2025-04-21T14:43:09.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "non hic quisquam",
        short_answer: "bus",
        image: null,
        category_id: 1,
        points: 50,
        question_type: 50,
        updatedAt: "2025-03-10T10:22:11.000Z",
        deletedAt: null,
      },
      team_name: "you",
    },
    {
      id: 898,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:43:00.000Z",
      updatedAt: "2025-04-21T14:43:08.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "illo unde quasi",
        short_answer: "monitor",
        image: null,
        category_id: 1,
        points: 30,
        question_type: 30,
        updatedAt: "2025-03-10T10:22:06.000Z",
        deletedAt: null,
      },
      team_name: "you",
    },
    {
      id: 897,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:43:00.000Z",
      updatedAt: "2025-04-21T14:43:05.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "perspiciatis dolorem maxime",
        short_answer: "transmitter",
        image: null,
        category_id: 1,
        points: 30,
        question_type: 30,
        updatedAt: "2025-03-10T10:22:03.000Z",
        deletedAt: null,
      },
    },
    {
      id: 896,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:43:00.000Z",
      updatedAt: "2025-04-21T14:43:04.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "sit sit nihil",
        short_answer: "array",
        image: null,
        category_id: 1,
        points: 10,
        question_type: 10,
        updatedAt: "2025-03-10T10:21:58.000Z",
        deletedAt: null,
      },
    },
    {
      id: 895,
      game_id: 78,
      category_id: 1,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:43:00.000Z",
      updatedAt: "2025-04-21T14:43:01.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "nihil facilis qui",
        short_answer: "application",
        image: null,
        category_id: 1,
        points: 10,
        question_type: 10,
        updatedAt: "2025-03-10T10:22:00.000Z",
        deletedAt: null,
      },
    },
    {
      id: 894,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:42:49.000Z",
      updatedAt: "2025-04-21T14:42:58.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "odio ab dicta",
        short_answer: "bus",
        image: null,
        category_id: 8,
        points: 50,
        question_type: 50,
        updatedAt: "2025-04-14T07:08:28.000Z",
        deletedAt: null,
      },
    },
    {
      id: 893,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:42:49.000Z",
      updatedAt: "2025-04-21T14:42:57.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "nesciunt et soluta",
        short_answer: "capacitor",
        image: null,
        category_id: 8,
        points: 50,
        question_type: 50,
        updatedAt: "2025-04-14T07:08:30.000Z",
        deletedAt: null,
      },
    },
    {
      id: 892,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:42:49.000Z",
      updatedAt: "2025-04-21T14:42:55.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "aliquam id ab",
        short_answer: "capacitor",
        image: null,
        category_id: 8,
        points: 30,
        question_type: 30,
        updatedAt: "2025-04-14T07:08:42.000Z",
        deletedAt: null,
      },
    },
    {
      id: 891,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:42:49.000Z",
      updatedAt: "2025-04-21T14:42:54.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "voluptas dolore accusamus",
        short_answer: "hard drive",
        image: null,
        category_id: 8,
        points: 30,
        question_type: 30,
        updatedAt: "2025-04-14T07:08:44.000Z",
        deletedAt: null,
      },
    },
    {
      id: 890,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:42:49.000Z",
      updatedAt: "2025-04-21T14:42:52.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "aspernatur ut beatae",
        short_answer: "matrix",
        image: null,
        category_id: 8,
        points: 10,
        question_type: 10,
        updatedAt: "2025-04-14T07:08:53.000Z",
        deletedAt: null,
      },
    },
    {
      id: 889,
      game_id: 78,
      category_id: 8,
      user_id: 34,
      is_answered: true,
      answered_by: 98,
      createdAt: "2025-04-21T14:42:49.000Z",
      updatedAt: "2025-04-21T14:42:51.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "fuga eos veritatis",
        short_answer: "card",
        image: null,
        category_id: 8,
        points: 10,
        question_type: 10,
        updatedAt: "2025-04-14T07:08:52.000Z",
        deletedAt: null,
      },
    },
    {
      id: 864,
      game_id: 73,
      category_id: 2,
      user_id: 34,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T14:38:26.000Z",
      updatedAt: "2025-04-21T14:38:26.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "in optio aut",
        short_answer: "monitor",
        image: null,
        category_id: 2,
        points: 50,
        question_type: 50,
        updatedAt: "2025-03-10T10:22:20.000Z",
        deletedAt: null,
      },
    },
    {
      id: 863,
      game_id: 73,
      category_id: 2,
      user_id: 34,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T14:38:26.000Z",
      updatedAt: "2025-04-21T14:38:26.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "ab aut voluptas",
        short_answer: "application",
        image: null,
        category_id: 2,
        points: 50,
        question_type: 50,
        updatedAt: "2025-03-10T10:22:19.000Z",
        deletedAt: null,
      },
    },
    {
      id: 862,
      game_id: 73,
      category_id: 2,
      user_id: 34,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T14:38:26.000Z",
      updatedAt: "2025-04-21T14:38:26.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "quos qui quae",
        short_answer: "matrix",
        image: null,
        category_id: 2,
        points: 30,
        question_type: 30,
        updatedAt: "2025-03-10T10:22:28.000Z",
        deletedAt: null,
      },
    },
    {
      id: 861,
      game_id: 73,
      category_id: 2,
      user_id: 34,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T14:38:26.000Z",
      updatedAt: "2025-04-21T14:38:26.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "dolores voluptatibus pariatur",
        short_answer: "system",
        image: null,
        category_id: 2,
        points: 30,
        question_type: 30,
        updatedAt: "2025-03-10T10:22:27.000Z",
        deletedAt: null,
      },
    },
    {
      id: 860,
      game_id: 73,
      category_id: 2,
      user_id: 34,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T14:38:26.000Z",
      updatedAt: "2025-04-21T14:38:26.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "hic aut eligendi",
        short_answer: "card",
        image: null,
        category_id: 2,
        points: 10,
        question_type: 10,
        updatedAt: "2025-03-10T10:24:16.000Z",
        deletedAt: null,
      },
    },
    {
      id: 859,
      game_id: 73,
      category_id: 2,
      user_id: 34,
      is_answered: true,
      answered_by: 88,
      createdAt: "2025-04-21T14:38:26.000Z",
      updatedAt: "2025-04-21T14:38:45.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "exercitationem animi voluptates",
        short_answer: "circuit",
        image: null,
        category_id: 2,
        points: 10,
        question_type: 10,
        updatedAt: "2025-03-10T10:24:13.000Z",
        deletedAt: null,
      },
    },
    {
      id: 822,
      game_id: 76,
      category_id: 9,
      user_id: 26,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T13:53:01.000Z",
      updatedAt: "2025-04-21T13:53:01.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "dolores ratione nisi",
        short_answer: "feed",
        image: null,
        category_id: 9,
        points: 50,
        question_type: 50,
        updatedAt: "2025-04-14T07:09:16.000Z",
        deletedAt: null,
      },
    },
    {
      id: 821,
      game_id: 76,
      category_id: 9,
      user_id: 26,
      is_answered: false,
      answered_by: null,
      createdAt: "2025-04-21T13:53:01.000Z",
      updatedAt: "2025-04-21T13:53:01.000Z",
      deletedAt: null,
      time_duration: 0,
      start_at: null,
      end_at: null,
      question: {
        question: "voluptatem corrupti molestias",
        short_answer: "transmitter",
        image: null,
        category_id: 9,
        points: 50,
        question_type: 50,
        updatedAt: "2025-04-14T07:09:14.000Z",
        deletedAt: null,
      },
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllGameQuestionQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "question.question",
      text: "Question",
      sort: true,
      headerStyle: {
        width: "200px",
      },
    },
    {
      dataField: "question.image",
      text: "Image",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // return row.firstname + row.lastname;
        // console.log(row.question.image);
        // if (row.question.image) {
        return (
          <img
            alt="package"
            src={row.question.image || "images/no_image_available.png"}
            loading="lazy"
            width={62}
            height={62}
            className="rounded-circle object-fit-cover"
          />
        );
        // }
      },
    },
    {
      dataField: "question.short_answer",
      text: "Short Answer",
      sort: true,
      headerStyle: {
        width: "100px",
      },
    },
    {
      dataField: "question.question_type",
      text: "Type",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        if (row.question.question_type === QUESTION_TYPE.EASY) {
          return "Easy";
        } else if (row.question.question_type === QUESTION_TYPE.MEDIUM) {
          return "Medium";
        } else {
          return "Hard";
        }
      },
    },
    {
      dataField: "question.points",
      text: "Points",
      sort: true,
      headerStyle: {
        width: "100px",
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug || row.id) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <div
                className={`${styles.btnBg} d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 text-white`}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleEditModalOpen(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center pe-1  `}
                ></span>
                <span>Details</span>
              </div>

              {/* <div
                className="d-flex justify-content-center align-items-center bg-danger text-white rounded-3 p-2 mx-2 "
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleDeleteModalOpen();
                }}
              >
                <span className={`d-flex align-items-center pe-1`}>
                  <MdDeleteForever />
                </span>
                <span>Delete</span>
              </div> */}
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DetailGameQuestionModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            // refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Game Management"} classes="text-black" />
        </div>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add Package"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                // refetch={refetch} // todo
                refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default GameQuestionManagementScreen;
